import { LottoItem } from '../../loyalty/lotto/models/lotto-item.model';
import { AuctionItem } from '../../loyalty/auction/models/auction-item.model';
import { MarketplaceItemExtended } from '../../loyalty/marketplace/models/marketplace-item-extended.model';
import { Scorecard } from '../../loyalty/scorecard/models/scorecard.model';

export type Preview = { _id: string } & (Scorecard | MarketplaceItemExtended | LottoItem | AuctionItem);

export const PreviewTypeId = { scorecard: 'scorecard', lotto: 'lotto', auction: 'auction', marketplace: 'marketplace' };
